/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Field_RevisionInputs */

const en_sync_field_revision = /** @type {(inputs: Sync_Field_RevisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`States sent`)
};

/**
* | output |
* | --- |
* | "States sent" |
*
* @param {Sync_Field_RevisionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_field_revision = /** @type {((inputs?: Sync_Field_RevisionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Field_RevisionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_field_revision(inputs)
});